import axios from "axios";
import { message } from "antd";
import { SERVER_URL, AUTH_TOKEN_NAME } from "./utilities";
import { serializeObjectToUrlParams } from "../helpers/url";
import { blobToPdf, openPdf } from "../helpers/pdfutils";


export const query = async (endpoint, query) => {
  const token = sessionStorage.getItem(AUTH_TOKEN_NAME);
  try {
    const qs = serializeObjectToUrlParams(query);
    const res = await axios.get(`${SERVER_URL}/${endpoint}?${qs}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    const response = res.data;
    if (!response.success) {
      return message.error(response.message);
    }
    return response;
  } catch (err) {
    console.log(err)
    message.error(err?.response?.data?.message ?? err.message ?? "Something went wrong")
  }
}


/**
 * @description Performs post operation
 * @param {string} endpoint the endpoint
 * @param {boolean} withCredentials whether to use credentials
 * @param {object} body the payload
 * @param {object?} query query if applicable
 * @param {string?} contentType content type if applicable
 * @param {boolean} formData whether body is a form data
 * @returns
 */
export const mutate = async (endpoint, withCredentials, body, query = {}, contentType = null, formData = false) => {
  try {
    const token = sessionStorage.getItem(AUTH_TOKEN_NAME);
    const headers = {
      Authorization: `Bearer ${token}`
    }
    // content type
    if (!!contentType) {
      Object.defineProperty(headers, 'Content-Type', {
        value: contentType,
        enumerable: true
      })
    }
    // define headers
    const headerPayload = withCredentials ? {
      withCredentials: true,
      headers: headers
    } : {};
    const qs = serializeObjectToUrlParams(query);
    const res = await axios.post(`${SERVER_URL}/${endpoint}?${qs}`, formData ? body : {
      ...body
    }, headerPayload);
    const { data: response } = res;
    if (!response.success) {
      return message.error(response.message);
    }
    return response;
  } catch (err) {
    console.log(err);
    message.error(err?.response?.data?.message ?? err.message ?? "Something went wrong")
    throw err
  }
}

export const update = async (endpoint, body, query = {}, contentType = null, formData = false) => {

  try {
    const token = sessionStorage.getItem(AUTH_TOKEN_NAME);

    const headers = {
      Authorization: `Bearer ${token}`
    }
    // content type
    if (!!contentType) {
      Object.defineProperty(headers, 'Content-Type', {
        value: contentType,
        enumerable: true
      })
    }

    const qs = serializeObjectToUrlParams(query);
    const { data: response } = await axios.put(`${SERVER_URL}/${endpoint}?${qs}`, formData ? body : {
      ...body
    }, {
      headers: headers
    });
    if (!response.success) {
      return message.error(response.message);
    }
    return response;
  } catch (err) {
    message.error(err?.response?.data?.message ?? err.message ?? "Something went wrong")
    return;
  }
}


export const destroy = async (endpoint) => {
  const token = sessionStorage.getItem(AUTH_TOKEN_NAME);
  try {
    const token = sessionStorage.getItem(AUTH_TOKEN_NAME);
    const { data: response } = await axios.delete(`${SERVER_URL}/${endpoint}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (err) {
    message.error(err?.response?.data?.message ?? err.message ?? "Something went wrong")
  }
}


export const uploadFile = async (endpoint, body, query) => {
  try {
    const token = sessionStorage.getItem(AUTH_TOKEN_NAME);
    const headerPayload = {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    };
    const qs = serializeObjectToUrlParams(query);
    const res = await axios.post(`${SERVER_URL}/${endpoint}?${qs}`, body, headerPayload);
    const { data: response } = res;
    if (!response.success) {
      return message.error(response.message);
    }
    return response;
  } catch (err) {
    console.log(err);
    message.error(err?.response?.data?.message ?? err.message ?? "Something went wrong")
    return;
  }
}


/**
 *
 * @param {string} endpoint
 * @param {string} filename
 * @param {string} extension
 * @param {boolean} open
 * @returns {Promise<{success}|any|boolean>}
 */
export const download = async (endpoint, filename, extension, open, params = {}) => {
  const token = sessionStorage.getItem(AUTH_TOKEN_NAME);
  try {
    const token = sessionStorage.getItem(AUTH_TOKEN_NAME);
    const qs = serializeObjectToUrlParams(params);
    const { data: response } = await axios.get(`${SERVER_URL}/${endpoint}?${qs}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob'
    });
    // download
    open ? openPdf(new Blob([response], { type: 'application/' + extension })) : blobToPdf(new Blob([response], { type: 'application/' + extension }), filename)
    return response;
  } catch (err) {
    message.error(err?.response?.data?.message ?? err.message ?? "Something went wrong")
    console.log(err)
    return;
  }
}
